import React from "react";
import GameRoom from './pages/GameRoom';
import GameHome from './pages/GameHome';
import GameSelection from './pages/GameSelection';
import ShanNineMee from './pages/ShanNineMee';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import { MultiBackend, TouchTransition } from "react-dnd-multi-backend";
import AppLayout from "./layouts/AppLayout";
import Test from "./pages/Test";
import AdminDashboard from './pages/AdminDashboard';
import RequireAdmin from './components/RequireAdmin';
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import AccountSettings from "./pages/AccountSettings";
import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/RequireAuth";
import GlobalControls from "./components/GlobalControls";
import { ToastProvider } from "./components/Toast";
import { CssBaseline } from "@mui/material";
import { AppThemeProvider } from './context/AppThemeContext';
import { SubscriptionProvider } from './context/SubscriptionProvider';
import SubscriptionGate from './components/SubscriptionGate';
import AdminSubscriptions from './pages/AdminSubscriptions';
import Home from './pages/Home';
import RequirePlayerSession from './components/RequirePlayerSession';

const HTML5toTouch = {
  backends: [
    {
      id: 'html5', // Unique ID for HTML5Backend
      backend: HTML5Backend,
      options: {},
      preview: true,
    },
    {
      id: 'touch',
      backend: TouchBackend,
      options: { enableMouseEvents: true },
      preview: true, // Enables drag previews
      transition: TouchTransition,
    },
  ],
};

function App() {
  return (
    <AppThemeProvider>
    <CssBaseline />
    <ToastProvider>
    <AuthProvider>
    <BrowserRouter 
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
    >
      <SubscriptionProvider>
      <GlobalControls />
      <DndProvider backend={MultiBackend} options={HTML5toTouch}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route element={<AppLayout/>}>
          <Route path="/account-settings" element={<RequireAuth><AccountSettings /></RequireAuth>} />
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<RequirePlayerSession><GameSelection /></RequirePlayerSession>} />
          <Route path="/poker/:roomId?" element={<RequirePlayerSession><SubscriptionGate feature="game"><GameHome /></SubscriptionGate></RequirePlayerSession>} />
          <Route path="/shan9mee/:roomId?" element={<RequirePlayerSession><SubscriptionGate game="shan9mee" feature="game"><ShanNineMee /></SubscriptionGate></RequirePlayerSession>} />
          <Route path="/shan-9-mee" element={<Navigate to="/shan9mee" replace />} />
          <Route path="/:roomId" element={<RequirePlayerSession><SubscriptionGate feature="game"><GameHome /></SubscriptionGate></RequirePlayerSession>} />
          <Route path="play/:roomId/:playerId" element={<RequirePlayerSession><GameRoom /></RequirePlayerSession>} />
          <Route path="admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="admin/subscriptions" element={<RequireAdmin><AdminSubscriptions /></RequireAdmin>} />
          <Route path="admin/subscription-settings" element={<RequireAdmin><AdminSubscriptions section="settings" /></RequireAdmin>} />
          <Route path="admin/app-settings" element={<RequireAdmin><AdminSubscriptions section="app" /></RequireAdmin>} />
          <Route path="test" element={<Test />} />
          </Route>
          <Route path="*" element={<Navigate to={'/'} replace />} />
        </Routes>
      </DndProvider>
      </SubscriptionProvider>
    </BrowserRouter>
    </AuthProvider>
    </ToastProvider>
    </AppThemeProvider>
  );
}

export default App;
